namespace SaBenefitCouponWidget {
    interface BenefitCouponResponse {
        couponCode?: string;
        alreadyIssued?: boolean;
    }

    function setSubmitting($widget: JQuery, isSubmitting: boolean): void {
        $widget.data("submitting", isSubmitting);
        $widget
            .find(".js-benefit-coupon-submit")
            .prop("disabled", isSubmitting);
        $widget
            .find(".js-benefit-coupon-form")
            .attr("aria-busy", String(isSubmitting));
        $widget
            .find(".js-benefit-coupon-loading")
            .prop("hidden", !isSubmitting);
    }

    function showCoupon(
        $widget: JQuery,
        response: BenefitCouponResponse,
    ): void {
        const couponCode = response.couponCode?.trim();
        if (!couponCode) {
            SaAlertUtils.defaultFire(
                "Coupon request error",
                "We received an unexpected response. Please try again.",
            );
            return;
        }

        const resultMessage = response.alreadyIssued
            ? String($widget.data("already-issued-message"))
            : String($widget.data("result-heading"));
        const $result = $widget.find(".js-benefit-coupon-result");

        $widget.find(".js-benefit-coupon-result-message").text(resultMessage);
        $widget.find(".js-benefit-coupon-code").text(couponCode);
        $widget
            .find(".js-benefit-coupon-copy-status")
            .text("")
            .prop("hidden", true);
        $result.prop("hidden", false).trigger("focus");
    }

    function showActiveMemberMessage($widget: JQuery): void {
        $widget.find(".js-benefit-coupon-form").prop("hidden", true);
        $widget.find(".js-benefit-coupon-result").prop("hidden", true);
        $widget
            .find(".js-benefit-coupon-active-member")
            .prop("hidden", false)
            .trigger("focus");
    }

    function requestCoupon($widget: JQuery): void {
        if ($widget.data("submitting")) {
            return;
        }

        const $membershipIdentifierInput = $widget.find(
            ".js-benefit-coupon-membership-identifier",
        );
        const externalMembershipIdentifier = String(
            $membershipIdentifierInput.val() ?? "",
        ).trim();

        if (!externalMembershipIdentifier) {
            SaAlertUtils.defaultFire(
                "IIBA membership email required",
                "Enter the email associated with your IIBA membership to request a coupon.",
            );
            $membershipIdentifierInput.trigger("focus");
            return;
        }

        $membershipIdentifierInput.val(externalMembershipIdentifier);
        const membershipIdentifierInput = $membershipIdentifierInput.get(0);
        if (
            membershipIdentifierInput instanceof HTMLInputElement &&
            !membershipIdentifierInput.checkValidity()
        ) {
            SaAlertUtils.defaultFire(
                "Valid IIBA membership email required",
                "Enter a valid email associated with your IIBA membership to request a coupon.",
            );
            $membershipIdentifierInput.trigger("focus");
            return;
        }

        setSubmitting($widget, true);

        $.ajax({
            type: "post",
            url: "/api/BenefitCoupons",
            contentType: "application/json",
            data: JSON.stringify({
                partner: String($widget.data("partner")),
                externalMembershipIdentifier,
            }),
            success: function (response: ApiResponse<BenefitCouponResponse>) {
                showCoupon($widget, response.data ?? {});
            },
            error: function (xhr: JQueryXHR) {
                if (xhr.status === 409) {
                    showActiveMemberMessage($widget);
                } else {
                    SaAlertUtils.defaultFireFromResponse(
                        "Coupon request error",
                        xhr,
                    );
                }
            },
            complete: function () {
                setSubmitting($widget, false);
            },
        });
    }

    async function copyCouponCode($widget: JQuery): Promise<void> {
        const couponCode = $widget
            .find(".js-benefit-coupon-code")
            .text()
            .trim();
        if (!couponCode) {
            return;
        }

        try {
            await navigator.clipboard.writeText(couponCode);
            $widget
                .find(".js-benefit-coupon-copy-status")
                .text(String($widget.data("copied-message")))
                .prop("hidden", false);
        } catch {
            SaAlertUtils.defaultFire(
                "Copy coupon code",
                "We couldn't copy the coupon code. Select and copy it manually.",
            );
        }
    }

    export function initializeWidgets(): void {
        $(".wBenefitCoupon__Marker").each(function () {
            const $widget = $(this);
            if ($widget.data("initialized")) {
                return;
            }

            $widget.data("initialized", true);
            $widget.on("submit", ".js-benefit-coupon-form", function (event) {
                event.preventDefault();
                requestCoupon($widget);
            });
            $widget.on("click", ".js-benefit-coupon-copy", function () {
                void copyCouponCode($widget);
            });
        });
    }
}

if (!SaNavigationUtils.NodeEnv.isTest()) {
    $(SaBenefitCouponWidget.initializeWidgets);
}

globalThis.SaBenefitCouponWidget = SaBenefitCouponWidget;
